import { getFragmentValue } from "../../../lib/url";
import { getCookie, setCookie, CookieKeys } from "../../../lib/cookies";
import { setAccessToken } from "../../visitWidgetApi";
import { initializeUser } from "../helpers/initializeUser";
import { initializeAnonymousUser } from "../helpers/initializeAnonymousUser";
import { logError } from "@lib/logger";
import { AppDispatch } from "@store/store";
import { setUserAction, signInAction } from "@store/sessionReducer";

const getToken = async (): Promise<string | undefined> => {
  let authToken: string | undefined;
  const oauthFlowToken = getFragmentValue("auth_token");
  if (oauthFlowToken !== undefined) {
    authToken = oauthFlowToken;
    await setCookie(CookieKeys.authToken, authToken);
    // remove the auth token fragment from the url
    window.history.pushState({}, "", "/");
  } else {
    authToken = await getCookie<string | undefined>(
      CookieKeys.authToken,
      undefined,
    );
  }

  return authToken;
};

/*
 * On app initialization set necessary state based on cookies.
 */
const refreshSessionAction = () => async (dispatch: AppDispatch) => {
  try {
    const authToken = await getToken();
    if (!authToken) {
      // The user is not logged in
      await initializeAnonymousUser(dispatch);
      return;
    }

    if (authToken) {
      setAccessToken(authToken);
      dispatch(signInAction({ authToken }));
    }

    const { user } = await initializeUser(authToken, dispatch);
    if (user) {
      dispatch(setUserAction({ user: user }));
    }
  } catch (error) {
    logError(error as Error);
  }
};

export { refreshSessionAction };
